import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_HOST
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('ifpk-token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('ifpk-token');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default api;

